import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const ExpandLessIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path fill="currentColor" d="m12.65 8.241 7 6-1.3 1.518L12 10.315 5.65 15.76l-1.3-1.518 7-6 .65-.558z" />
  </BaseIcon>
)
